const EVIDENCE_TYPE_DETAILS = {
    documents: {
        label: 'Documents',
        icon: 'fileTypeUndefined',
        description: '.doc, .docx, .pdf, text entry (including typed and handwritten)',
        title: 'What the AI flags in document submissions',
        flag: ['Claims with no attribution', 'Thesis not stated', 'Quoted text without citation', 'File problems'],
        ignore: [
            'Regional spelling or dialect',
            'Citation style variants',
            'Heading and formatting choices',
            'Paragraph length',
            'Sentence variety',
        ],
    },
    videos: {
        label: 'Videos',
        icon: 'video',
        description: '.mp4, .mpg, .mpeg, .mov (including video services)',
        title: 'What the AI flags in video submissions',
        flag: ['Claims with no evidence', 'A required step never performed', 'Audio or video unusable'],
        ignore: [
            'Filler words (um, like, you know)',
            'Speaking pace',
            'Accent or pronunciation',
            'Reading from notes',
            'Slide template polish',
            'Camera framing and background',
            'Dress and appearance',
            'Nervous gestures',
        ],
    },
    slides: {
        label: 'Slides',
        icon: 'presentation',
        description: '.pptx, .ppt, .pdf',
        title: 'What the AI flags in slide submissions',
        flag: ['A claim on a slide with no source', 'Slide never spoken to'],
        ignore: ['Template and theme choice', 'Font and colour choices', 'Slide count', 'Animations and transitions'],
    },
    spreadsheets: {
        label: 'Spreadsheets',
        icon: 'spreadsheet',
        description: '.xlsx, .csv (including formulae, values, and graphs)',
        title: 'What the AI flags in spreadsheet submissions',
        flag: ['A hardcoded value where a formula was asked for', 'Broken references', 'File problems'],
        ignore: ['Cell formatting and colour', 'Column widths', 'Sheet naming', 'Number of helper columns'],
    },
};

export default EVIDENCE_TYPE_DETAILS;
